import { render, staticRenderFns } from "./MoreInfo.vue?vue&type=template&id=5c57c62e&scoped=true&"
import script from "./MoreInfo.vue?vue&type=script&lang=js&"
export * from "./MoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./MoreInfo.vue?vue&type=style&index=0&id=5c57c62e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57c62e",
  null
  
)

export default component.exports